import { createGlobalStyle } from 'styled-components';

const Styles = createGlobalStyle`

    body,
    html,
    a {
        font-family: 'Ubuntu', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #fff;
        overflow-x: hidden;
    }

    a:hover {
        color: #000;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Ubuntu', sans-serif;
        color: #0a1f44;
        font-size: 2.575rem;
        line-height: 3.0625rem;
      
        @media only screen and (max-width: 414px) {
          font-size: 1.625rem;
        }
    }

    p {
        color: #343D48;
        font-size: 1.125rem;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #2E186A;

        :hover {
            color: #2e186a;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        padding: 1.25rem;
        text-align: left;
        padding-top: 2.5rem;
        padding-right: 2rem;
    }

    .anticon,
    .ant-notification-notice-icon-success {
        color: rgb(255,130,92);
    }

    .bIEnst {
        position: relative;
        max-width: 100% !important; 
    }

    .dQopaR {
        position: relative;
        padding: 2rem 0 8rem 5rem;
        margin-top: -1rem;
    }

    .joYrkM {
        position: relative;
        padding: 1rem 0 3rem;
        text-align: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-top: -10rem;
    }

    .dFwojS {
        position: relative;
        padding: 1rem 0 3rem;
        text-align: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-top: -9rem;
    }

    #message {
        display: inline-block;
        width: 100%;
        padding: 10px 5px;
        margin-bottom: -0.625rem;
        margin-top: 5rem;
    }

    @media only screen and (max-width: 600px) {
        #message {
            display: inline-block;
            width: 100%;
            padding: 10px 5px;
            margin-bottom: -0.625rem;
            margin-top: -2rem;
        }
        #product {
            margin-top: -2em;
        }
    }

    .email-content {
        margin-top: 2rem;
    }

    .about {
        position: relative !important;
        max-width: 100% !important; 
    }

    #about {
        padding: 0 0 0 0 !important;
        margin-left: 4em !important;
        //margin-bottom: 8em !important;
    }
`;

export default Styles;
